import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = [
    'input',
    'instructionsText',
    'incorrectIcon',
    'correctIcon',
  ];

  checkPasswordLength() {
    this.incorrectIconTarget.classList.toggle(
      'd-none',
      this.inputTarget.value.length > 11
    );
    this.instructionsTextTarget.classList.toggle(
      'text-primary-600',
      this.inputTarget.value.length < 12
    );

    this.instructionsTextTarget.classList.toggle(
      'text-success-700',
      this.inputTarget.value.length > 11
    );
    this.correctIconTarget.classList.toggle(
      'd-none',
      this.inputTarget.value.length < 12
    );
  }
}
